import './index.css';
import { getNotNullish } from '@hg-akademie-ban/vamos-viva-type-utils';
import { LicenseInfo } from '@mui/x-license';
import { setDefaultOptions } from 'date-fns';
import { de } from 'date-fns/locale';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ErrorBoundary } from './components/general';
import { AzureApplication, getBackendConfig } from './main.utils';
import { BackendConfigContext } from './utils';

LicenseInfo.setLicenseKey(
  'ed34da2638149e3bf4610520c906b012Tz0xMjg0NjEsRT0xODEwNTExOTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=',
);

try {
  const backendConfig = await getBackendConfig();
  const msalInstance = await AzureApplication.createFromBackendConfig(backendConfig);

  // set default locale for date-fns - saves us from having to set the locale each time :)
  setDefaultOptions({ locale: de });

  createRoot(getNotNullish(document.querySelector('#root'))).render(
    <React.StrictMode>
      <BackendConfigContext value={backendConfig}>
        <App msalInstance={msalInstance} />
      </BackendConfigContext>
    </React.StrictMode>,
  );
} catch (error: unknown) {
  createRoot(getNotNullish(document.querySelector('#root'))).render(
    <React.StrictMode>
      <ErrorBoundary error={error} />
    </React.StrictMode>,
  );
}
